const enc = new TextEncoder();
const dec = new TextDecoder();
let KEY = null;

export const setVaultKey = (k) => { KEY = k; };
export const getVaultKey = () => KEY;
const need = () => { if (!KEY) throw new Error("Vault is locked"); return KEY; };

export async function seal(bytes) {
  const iv = crypto.getRandomValues(new Uint8Array(12));
  return { iv, ct: await crypto.subtle.encrypt({ name: "AES-GCM", iv }, need(), bytes) };
}
export const unseal = ({ iv, ct }) => crypto.subtle.decrypt({ name: "AES-GCM", iv }, need(), ct);
export const sealJSON = (o) => seal(enc.encode(JSON.stringify(o)));
export const unsealJSON = async (e) => JSON.parse(dec.decode(await unseal(e)));
